import {ChangeEvent, FC} from 'react';
import {FormField} from 'ui';
import {extractSnilsDigits, SnilsStepValues} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './SnilsStep.module.css';

type Props = {
	values: SnilsStepValues;
	onChange: (patch: Partial<SnilsStepValues>) => void;
};

export const SnilsStep: FC<Props> = ({values, onChange}) => {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange({snils: extractSnilsDigits(event.target.value)});
	};

	return (
		<StepLayout>
			<StepLayout.Title>Введите номер СНИЛС</StepLayout.Title>

			<StepLayout.Content className={styles.field}>
				<FormField label="Номер">
					<TextInput
						name="snils"
						value={values.snils}
						placeholder="00000000000"
						inputMode="numeric"
						autoComplete="off"
						onChange={handleChange}
						onClear={() => onChange({snils: ''})}
					/>
				</FormField>
			</StepLayout.Content>
		</StepLayout>
	);
};
